import { type } from 'arktype';

export const notificationQuerySchema = type({
  'employeeId?': 'string',
  'type?': 'string',
  'read?': 'boolean',
});

export type NotificationQuery = typeof notificationQuerySchema.t;
